/* Glacier — product.js (loaded on product pages only, deferred)
   Variant selection, price/availability updates, gallery switching. */
(() => {
  "use strict";

  const dataEl = document.getElementById("ProductData");
  if (!dataEl) return;
  const product = JSON.parse(dataEl.textContent);
  const form = document.querySelector("form[data-ajax-cart]");
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  const priceEl = document.querySelector("[data-product-price]");
  const submitBtn = form ? form.querySelector('[type="submit"]') : null;

  // Handles every Shopify money-format placeholder (amount, amount_no_decimals,
  // amount_with_comma_separator, …), not just {{amount}}
  const money = (cents) => {
    const fmt = dataEl.dataset.moneyFormat || "${{amount}}";
    const n = cents / 100;
    const keyMatch = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = keyMatch ? keyMatch[1] : "amount";
    const num = (precision, thousands, decimal) => {
      const parts = n.toFixed(precision).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    let value;
    switch (key) {
      case "amount_no_decimals": value = num(0, ",", "."); break;
      case "amount_with_comma_separator": value = num(2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = num(2, "'", "."); break;
      case "amount_no_decimals_with_space_separator": value = num(0, " ", ","); break;
      case "amount_with_space_separator": value = num(2, " ", ","); break;
      case "amount_with_period_and_space_separator": value = num(2, " ", "."); break;
      default: value = num(2, ",", ".");
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  function selectedOptions() {
    return [...document.querySelectorAll(".variant-fieldset")].map(
      (fs) => fs.querySelector("input:checked")?.value
    );
  }

  function findVariant(options) {
    return product.variants.find((v) => v.options.every((opt, i) => opt === options[i]));
  }

  function updateUI(variant) {
    if (!variant) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Unavailable";
      }
      return;
    }
    if (idInput) idInput.value = variant.id;

    if (priceEl) {
      let html = "";
      if (variant.compare_at_price > variant.price) {
        html = `<s class="price__compare">${money(variant.compare_at_price)}</s><span class="price__sale">${money(variant.price)}</span>`;
      } else {
        html = `<span>${money(variant.price)}</span>`;
      }
      priceEl.innerHTML = html;
    }

    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? submitBtn.dataset.labelAdd || "Add to cart"
        : submitBtn.dataset.labelSoldOut || "Sold out";
    }

    // Savings badge
    const saveEl = document.querySelector("[data-save-badge]");
    if (saveEl) {
      if (variant.compare_at_price > variant.price) {
        saveEl.textContent = `Save ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`;
        saveEl.style.display = "";
      } else {
        saveEl.style.display = "none";
      }
    }

    // Stock indicator
    const stockEl = document.querySelector("[data-stock]");
    if (stockEl) {
      if (!variant.available) {
        stockEl.style.display = "none";
      } else if (
        variant.inventory_management &&
        typeof variant.inventory_quantity === "number" &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= 5
      ) {
        stockEl.innerHTML = `<span class="stock-dot stock-dot--low"></span> Only ${variant.inventory_quantity} left — order soon`;
        stockEl.style.display = "";
      } else {
        stockEl.innerHTML = '<span class="stock-dot"></span> In stock, ready to ship';
        stockEl.style.display = "";
      }
    }

    // Switch gallery to the variant's featured media
    if (variant.featured_media) switchMedia(String(variant.featured_media.id));

    // Keep URL shareable
    const url = new URL(location.href);
    url.searchParams.set("variant", variant.id);
    history.replaceState({}, "", url);
  }

  document.addEventListener("change", (e) => {
    if (!e.target.closest(".variant-fieldset")) return;
    updateUI(findVariant(selectedOptions()));
  });

  /* ---------- Gallery ---------- */
  const mainImg = document.querySelector("[data-gallery-main] img");

  function switchMedia(mediaId) {
    const thumb = document.querySelector(`[data-media-id="${mediaId}"]`);
    if (!thumb || !mainImg) return;
    const img = thumb.querySelector("img");
    mainImg.src = img.dataset.fullSrc || img.src;
    mainImg.srcset = img.dataset.fullSrcset || "";
    mainImg.alt = img.alt;
    document
      .querySelectorAll(".product-gallery__thumb")
      .forEach((t) => t.setAttribute("aria-current", t === thumb ? "true" : "false"));
  }

  document.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-media-id]");
    if (!thumb) return;
    const mediaId = thumb.dataset.mediaId;
    switchMedia(mediaId);

    // Reverse sync: clicking an image selects the variant it belongs to
    const matches = product.variants.filter(
      (v) => v.featured_media && String(v.featured_media.id) === mediaId
    );
    if (!matches.length) return; // image not tied to a variant — just view it
    const variant = matches.find((v) => v.available) || matches[0];

    document.querySelectorAll(".variant-fieldset").forEach((fieldset, i) => {
      const input = [...fieldset.querySelectorAll("input")].find(
        (inp) => inp.value === variant.options[i]
      );
      if (input) input.checked = true; // programmatic check fires no change event, so no double update
    });
    updateUI(variant);
  });
})();
